import { fireClickedOptionEvent } from '../../StoreHomePage/BogoClothDiaper/instrumentation';
import React from 'react';
//import { fireClickedOptionEvent } from "../../StoreHomePage/BogoClothDiaper/common";
import { DiaperOfferData } from '../B2G1RadioOption/B2G1Const';

import {
  RadioOptionContainer,
  RadioOptionSection,
} from '../B2G1RadioOption/styled';
import DiaperVarient from '../DiaperPageRadioOptions/DiaperVarient';
import {
  diaperRadioData,
  diaperRadioDataVarient2,
} from '../DiaperPageRadioOptions/constant';
import DaiperVarientLive from '../DiaperPageRadioOptions/DaiperVarientLive';
import { updatedExperimentUserType } from '../DiaperPageRadioOptions/utils';

export default function DiaperRadioOptionNew(props) {
  const {
    setHideStickyStrip,
    setOfferCartData,
    setChangeCartCount,
    clientSideApiCall,
    option,
    setOption,
    newDiaperVersion,
    setShowHeading,
    setShowAnimation,
  } = props;
  let { experimentUserType } = props;
  experimentUserType = updatedExperimentUserType(experimentUserType);

  const onChangeHandler = (data) => {
    setOption(data?.id);
    setChangeCartCount(true);
    localStorage.setItem('option', data?.id);
    if (data?.id === '2') {
      setHideStickyStrip(true);
      // setOfferCartData({});
    } else {
      clientSideApiCall();
      setHideStickyStrip(false);
    }
    fireClickedOptionEvent(data?.offerName, 'DIAPERDEAL');

    setShowHeading(false);
    setTimeout(() => {
      setShowHeading(true);
    }, [400]);
  };
  const onClickHandler = (data) => {
    if (option == data?.id) {
      document.getElementById(`twoGrid`)?.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
      });
      setShowAnimation(true);
      setTimeout(() => {
        setShowAnimation(false);
      }, 1000);
    }
  };
  const getVarientBasisOfType = (experimentUserType) => {
    switch (experimentUserType) {
      case 'A':
        return (
          <DaiperVarientLive
            DiaperOfferData={DiaperOfferData}
            option={option}
            onChangeHandler={onChangeHandler}
            onClickHandler={onClickHandler}
          />
        );
      case 'B':
        return (
          <DiaperVarient
            onChangeHandler={onChangeHandler}
            option={option}
            diaperRadioData={diaperRadioData}
            varient={1}
          />
        );
      case 'C':
        return (
          <DiaperVarient
            onChangeHandler={onChangeHandler}
            option={option}
            diaperRadioData={diaperRadioDataVarient2}
            varient={2}
          />
        );
      default:
        break;
    }
  };
  return (
    <RadioOptionContainer
      newDiaperVersion={newDiaperVersion}
      experimentUserType={experimentUserType}
    >
      {/* <BestOfferTitle>Best Offers Available For You</BestOfferTitle> */}
      <RadioOptionSection>
        {getVarientBasisOfType(experimentUserType)}
      </RadioOptionSection>
    </RadioOptionContainer>
  );
}
